import { useCallback } from 'react'
import { ClearIcon } from '@weblite/icons'
import { ButtonBase, IconButton, styled, Typography } from '@mui/material'
import { t } from '$i18n'
import { AvatarSize } from '$common/avatar'
import { AvatarGroup } from '$common/avatar-group'
import { useJoinHallRequests } from '$logic/subscription/react-hook'
import { showJoinHallRequestsModal } from '$comp/modals/join-channel-request-list'
import { JOIN_HALL_REQUESTS_BAR_HEIGHT } from '$comp/_app/components/chat/components/conf'
import { useRoom } from '$logic/room/react-hook'

export function JoinHallRequestsBar({
  roomId,
  onClose,
}: {
  roomId: string
  onClose: () => unknown
}) {
  const { items: joinHallRequests, totalCount } = useJoinHallRequests({
    hallId: roomId,
  })

  const room = useRoom(roomId)

  const handleClose = useCallback(
    (e: React.SyntheticEvent) => {
      e.preventDefault()
      onClose()
    },
    [onClose],
  )

  if (!joinHallRequests?.length) return null

  return (
    <Root>
      <BackgroundButton onClick={() => showJoinHallRequestsModal(roomId)}>
        <AvatarGroup
          userIds={joinHallRequests.map(({ userId }) => userId)}
          // eslint-disable-next-line no-underscore-dangle
          size={AvatarSize._4XS}
          showOthersCount
          sx={{ cursor: 'pointer' }}
        />
        <Typography variant="subtitle4" color="primary500">
          {t('JoinHallRequests.requestsBarTitle')(totalCount, room?.type)}
        </Typography>

        <CloseButtonPlaceholder />
      </BackgroundButton>
      <IconButton
        sx={{
          width: '32px',
          height: '32px',
          position: 'absolute',
          top: '4px',
          left: '12px',
        }}
        onClick={handleClose}
      >
        <ClearIcon
          sx={{ color: 'neutral500', width: '24px', height: '24px' }}
        />
      </IconButton>
    </Root>
  )
}

const Root = styled('div')`
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;

  width: 100%;
  height: ${JOIN_HALL_REQUESTS_BAR_HEIGHT}px;
  overflow: hidden;
`

const BackgroundButton = styled(ButtonBase)`
  width: 100%;
  height: 100%;
  padding: 0 8px 0 12px;
  display: flex;
  gap: 8px;
  align-items: center;
  justify-content: flex-start;
  background-color: ${({ theme }) => theme.palette.primary50};
`

const CloseButtonPlaceholder = styled('div')`
  width: 32px;
  height: 32px;
  background: transparent;
`
